<template>
	<div
		id="industry-management"
		:class="[!isWeb ? 'mobile-industry-management' : '', !isWeb && isSafari ? 'safari' : '']"
	>
		<div class="industry-management__body">
			<TableFilter :isWeb="isWeb" @searchFromInput="searchFromInput" />
			<IndustryTable
				:isWeb="isWeb"
				:currentPage="page"
				@changePage="changePage"
				@refreshOperationType="refreshOperationType"
				@orderByHeader="orderByHeader"
			/>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import { GET_ALL_INDUSTRYS } from '@/store/modules/industryManagement/actions';
import TableFilter from '@/components/modules/Industry/IndustryManagement/TableFilter/TableFilter.vue';
import IndustryTable from '@/components/modules/Industry/IndustryManagement/Table/Table.vue';

export default {
	name: 'IndustryManagement',
	components: { TableFilter, IndustryTable },
	data: () => ({
		windowWidth: window.innerWidth,
		page: 1,
		searchParams: null,
		headerSelected: null,
		orderSelected: null,
	}),
	created() {
		this.refreshOperationType();
	},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},
	methods: {
		...mapActions('industryManagement', {
			getIndustries: GET_ALL_INDUSTRYS,
		}),
		onResize() {
			this.windowWidth = window.innerWidth;
		},
		changePage(params) {
			this.page = params.params;
			this.refreshOperationType();
		},
		searchFromInput(params) {
			this.searchParams = params.toString();
			this.page = 1;
			this.refreshOperationType();
		},
		orderByHeader(param) {
			this.headerSelected = param;

			if (!this.orderSelected || this.orderSelected == 'ASC') {
				this.orderSelected = 'DESC';
			} else {
				this.orderSelected = 'ASC';
			}

			this.refreshOperationType();
		},
		refreshOperationType() {
			let params = `?limit=20&page=${this.page}`;

			if (this.searchParams) {
				if (this.searchParams.includes('#')) {
					this.searchParams = this.searchParams.replace('#', '%23');
				}

				params += `&search=${this.searchParams}`;
			}

			if (this.headerSelected)
				params += `&orderColumn=${this.headerSelected}&orderDirection=${this.orderSelected}`;

			this.getIndustries({ vm: this, params: params });
		},
	},
	computed: {
		isWeb() {
			return this.windowWidth > 992;
		},
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
	},
};
</script>

<style lang="scss">
@import 'IndustryManagement.scss';
</style>
